import React, { useEffect, useState } from 'react';
import { api } from '../../app/Api/ApiSlice';
import { toast } from 'react-toastify';
import InfiniteScroll from 'react-infinite-scroll-component';
import UserCard from '../../components/UserCard';
import Loader from '../../components/Loader';

const MyFriends = () => {
    const [friends, setFriends] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [hasMore,setHasMore] = useState(false)
    const [page,setPage] = useState(1)

    useEffect(() => {
        const getFriends = async () => {
            try {
                setIsLoading(true); 
                const response = await api.get("/community/friends",{params:{page}});
                // console.log(response)
                setFriends(response?.data);
                if(response?.data.length < 20){
                    setHasMore(false)
                }
            } catch (error) {
                toast.error(error.response?.data?.message || "Failed to fetch friends");
            } finally {
                setIsLoading(false); 
            }
        };

        getFriends(); 
    }, []);

    const handleRefresh = async()=>{}

    return (
        <div className='users-page-container'>
            <h2 className="users-list-header">My Friends</h2>
         <InfiniteScroll
           dataLength={friends.length}
           next={() => setPage((prev) => prev + 1)}
           hasMore={hasMore}
           refreshFunction={handleRefresh}
           Loader={<Loader />}
           pullDownToRefresh={true}
         >
            <div className="friends-list">
                {isLoading && <Loader />}
                {!isLoading && friends.length === 0 &&
                        <p className="not-found-msg">No friends found</p>
                    }
                {
                    friends && friends.map((frd)=>(
                        <UserCard user={frd} />
                    ))
                }
            </div>
         </InfiniteScroll>
        </div>
    );
};

export default MyFriends;
